import React, { useState } from 'react';
import { FaAngleUp, FaAngleDown } from 'react-icons/fa6';
import {  RegistrationData, PersonInfo  } from '@interface';

const CollapsibleCard: React.FC<{ person: PersonInfo }> = ({ person }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="text-[13px] mt-3 pb-3">
			<div
				className="flex justify-between items-center cursor-pointer"
				onClick={() => setIsOpen(!isOpen)}
			>
				<div className="font-semibold w-full flex justify-between pr-5">
					<span>{person.role}:</span>
					<span>{person.name}</span>
				</div>
				{isOpen ? <FaAngleUp size={15} /> : <FaAngleDown size={15} />}
			</div>
			{isOpen && (
				<div className="mt-2  space-y-2 px-4">
					<div className="flex justify-between">
						<span className="font-semibold">Title:</span>
						<span>{person.title}</span>
					</div>
					<div className="flex justify-between">
						<span className="font-semibold">Business:</span>
						<span>{person.business}</span>
					</div>
					<div className="flex justify-between">
						<span className="font-semibold">Address:</span>
						<span>{person.address}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export const OwnerShip: React.FC<RegistrationData> = ({
    lastregistrationdate,
    contacts, 
    ownername,
    ownershipType
}) => {
	return (
		<div className="max-w-md mx-auto space-y-3">
			<div className="text-center">
				<span>Date of last registration:</span>{' '}
				<span>{lastregistrationdate}</span>
			</div>
			<div>
				{contacts.map((person, index) => (
					<CollapsibleCard key={index} person={person} />
				))}
			</div>
			<div className="mt-[10px] space-y-5">
				<p>
                    This {"property's"} ownership type is <b>{ownershipType}</b>.
				</p>
				<p>
					The owner on record with the DOF is <b>{ownername}</b>.
				</p>
				{/* <p>
					There are <b>53</b> properties associated with this property.
				</p> */}
			</div>
		</div>
	);
};
